import { Slice, createSlice } from "@reduxjs/toolkit";
import { fetchEquipmentAndDevices } from "../thunk/SitesOverviewThunk";

const initialData: any = [];

const EquipmentAndDeviceSlice: Slice<any, {}, "EquipmentAndDeviceSlice"> = createSlice({
    name: "EquipmentAndDeviceSlice",
    initialState: { data: initialData, isLoading: false, error: "" },
    reducers: {},
    extraReducers(builder) {
        builder.addCase(fetchEquipmentAndDevices.pending, (state, action) => {
            state.isLoading = true
        });
        builder.addCase(fetchEquipmentAndDevices.fulfilled, (state, action) => {
            state.isLoading = false
            state.data = action.payload
        });
        builder.addCase(fetchEquipmentAndDevices.rejected, (state, action) => {
            state.isLoading = false
            state.error = action.error.message ?? ""
        });
    }
})

export default EquipmentAndDeviceSlice;
